var map = {
	"./photo_0.webp": 1017,
	"./photo_1.webp": 1018,
	"./photo_2.webp": 1019,
	"./photo_3.webp": 1020,
	"./photo_4.webp": 1021,
	"./photo_5.webp": 1022
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1016;